import { useCounter, useSetState } from '@mantine/hooks';
/** @file Todo: Search std Possibly only used in Identification */
import Rolling from '@assets/gif/rolling.gif';
import SearchNotificationImage from '@assets/svg/search-notification-light.svg';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { useState } from '@hookstate/core';
import { ClickAwayListener } from '@material-ui/core';
import { Block } from '@pages/Products/components/AddEquipmentModal/components/AddProduct/AddProduct.styles';
import { AddProductContent } from '@pages/Products/components/AddEquipmentModal/components/AddProduct/components';
import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import {
  BlueButton,
  Buttons,
  Container,
  Div,
  Line,
  LoadingImg,
  Search,
  SearchButton,
  SearchContainer,
  SearchImg,
  ShowOptions,
  StyledOption,
} from './SearchBarExpansiveModel.styles';

export interface Callbacks {
  onSuccess: (key: number) => void;
  onError: (key: number) => void;
  key: number;
}
export interface CriticalDataProduct {
  content: string;
  id: string;
  manufacturerName?: string;
  imageUrl?: string;
}
interface SearchBarProps {
  showOptions: CriticalDataProduct[];
  searchText: string | null;
  placeholder: string;
  readOnly?: boolean;
  onSearch: (cbs: Callbacks) => void;
  onCloseIconClick: () => void;
  onSelect: (input: CriticalDataProduct) => void;
  onChange: (value: string) => void;
  clearResults: () => void;
  selectedValue: string | null;
  isActuallyDisabled?: boolean;
}
function SearchBarExpansiveModel(props: SearchBarProps) {
  const {
    searchText,
    readOnly,
    placeholder,
    onChange,
    onSearch,
    onCloseIconClick,
    showOptions,
    onSelect,
    clearResults,
    selectedValue,
    isActuallyDisabled,
  } = props;
  const handleClickAway = () => {
    clearResults();
  };
  const open = useState(false);
  const [count, handlers] = useCounter();
  // iNPUT VALUES
  const [searchState, setSearchState] = useSetState({
    loading: false,
    showErase: Boolean(selectedValue),
  });
  const { loading, showErase } = searchState;
  useEffect(() => {
    // For when we update single inputs
    const _showErase = Boolean(selectedValue);
    if (_showErase) {
      setSearchState({ showErase: _showErase, loading: false });
    }
    setSearchState({ showErase: _showErase });
  }, [selectedValue]);
  const cbs: Callbacks = {
    key: count,
    onSuccess(key) {
      if (key === count) {
        setSearchState({
          loading: false,
          showErase: true,
        });
      }
    },
    onError(key) {
      if (key === count) {
        setSearchState({
          loading: false,
          showErase: true,
        });
      }
    },
  };
  const $searchText = selectedValue ?? searchText ?? '';
  // Either controlled or uncontrolled
  let $readOnly = Boolean(selectedValue);
  if (typeof readOnly === 'boolean') {
    $readOnly = readOnly;
  }

  const shouldShowErase =
    !isActuallyDisabled && !loading && showErase && $searchText.length > 0;
  const shouldShowSearch =
    !isActuallyDisabled && !loading && !showErase && $searchText.length > 0;
  let searchClass = 'close';
  if (shouldShowSearch) {
    searchClass = 'search';
  }
  return (
    <Div>
      <SearchContainer data-disabled={isActuallyDisabled}>
        <div>
          <SearchImg
            src={SearchNotificationImage}
            alt="search"
            // Todo: Rename to isVisible
            isDisabled={$readOnly || isActuallyDisabled}
          />
        </div>
        <div>
          <Search
            value={$searchText}
            readOnly={$readOnly}
            autoComplete="off"
            placeholder={placeholder}
            className={searchClass}
            onChange={e => {
              if (!$readOnly && !isActuallyDisabled) {
                setSearchState({
                  showErase: false,
                });
                onChange(e.target.value);
              }
            }}
            onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
              const staticCount = count;
              if (loading && !showErase) {
                handlers.increment();
              }
              if (e.key === 'Enter' && !showErase && $searchText.length > 0) {
                const newCount = loading ? staticCount + 1 : staticCount;
                setSearchState({
                  loading: true,
                  showErase: false,
                });
                onSearch({ ...cbs, key: newCount });
              }

              if (
                loading &&
                !showErase &&
                (e.key === 'Escape' || e.key === 'Esc')
              ) {
                setSearchState({ loading: false });
                clearResults();
              }
            }}
            disabled={isActuallyDisabled}
            haveResults={showOptions.length > 0}
          />
        </div>
        {!isActuallyDisabled && loading && (
          <div>
            <LoadingImg src={Rolling} alt="loading" />
          </div>
        )}
        {shouldShowErase && <BActionIcon ml={-36} onClick={onCloseIconClick} />}
        {shouldShowSearch && (
          <div>
            <SearchButton
              onClick={() => {
                setSearchState({
                  loading: true,
                  showErase: false,
                });
                return onSearch(cbs);
              }}
            >
              Search
            </SearchButton>
          </div>
        )}
      </SearchContainer>
      {!isActuallyDisabled && showOptions.length > 0 && <Line />}
      {!isActuallyDisabled && showOptions.length > 0 && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <ShowOptions haveResults={showOptions.length > 0}>
            <Container haveResults={showOptions.length > 0}>
              {showOptions.map(item => (
                <StyledOption
                  onClick={() => {
                    onSelect(item);
                    clearResults();
                  }}
                >
                  {`${item.content} (${item.manufacturerName})`}
                </StyledOption>
              ))}
            </Container>
            <Buttons>
              <BlueButton onClick={() => open.set(true)}>
                Add New Product
              </BlueButton>
            </Buttons>
          </ShowOptions>
        </ClickAwayListener>
      )}
      <CSSTransition
        in={open.get()}
        timeout={1}
        classNames="my-node"
        unmountOnExit
        onEnter={() => open.set(true)}
        onExited={() => open.set(false)}
      >
        <Block>
          <AddProductContent openAddField={open} onSelect={onSelect} />
        </Block>
      </CSSTransition>
    </Div>
  );
}

export { SearchBarExpansiveModel };
